import { render, staticRenderFns } from "./EmployeeChildInfo.vue?vue&type=template&id=b3af98b8"
import script from "./EmployeeChildInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeChildInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports